import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Tabs,
  Tab,
  Typography
} from '@mui/material';
import UserInfoTab from './UserInfoTab';
import UserPTOTab from './UserPTOTab';
import UserSecurityTab from './UserSecurityTab';

const UserDialog = ({
  open,
  handleClose,
  formData,
  setFormData,
  handleInputChange,
  handleSubmit,
  selectedUser,
  showPassword,
  setShowPassword,
  teams,
  memberTeamDropdownOpen,
  setMemberTeamDropdownOpen,
  ledTeamsDropdownOpen,
  setLedTeamsDropdownOpen,
  handleCloseDropdown,
  systemTwoFactorEnabled,
  twoFactorUpdating,
  passwordChangeUpdating,
  handleTwoFactorToggle,
  handleForcePasswordChangeToggle,
  error
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="md" 
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          bgcolor: 'background.paper',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column'
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <DialogTitle sx={{
        '@media (max-width:600px)': {
          fontSize: '1.1rem',
          padding: '16px',
          paddingBottom: '8px',
        }
      }}>
        {selectedUser ? `Edit User - ${formData.firstName} ${formData.lastName}` : 'Add New User'}
      </DialogTitle>
      <Box sx={{ 
        borderBottom: 1, 
        borderColor: 'divider', 
        px: 3,
        '@media (max-width:600px)': {
          px: 2,
        }
      }}>
        <Tabs 
          value={formData.currentTab} 
          onChange={(e, newValue) => setFormData(prev => ({ ...prev, currentTab: newValue }))}
          sx={{
            '@media (max-width:600px)': {
              '& .MuiTab-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                minWidth: 'auto',
                padding: '8px 12px',
              }
            }
          }}
        >
          <Tab label="Info" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }} />
          {selectedUser && formData.role !== 'admin' && formData.role !== 'accountant' && 
            <Tab label="PTO" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }} />}
          {selectedUser && <Tab label="Security" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }} />}
        </Tabs>
      </Box>
      <DialogContent sx={{ 
        minHeight: '400px',
        maxHeight: '60vh',
        flex: 1,
        overflow: 'auto',
        '@media (max-width:600px)': {
          padding: '16px',
          minHeight: '300px',
          maxHeight: '50vh',
        }
      }}>
        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
        <Box 
          component="form" 
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleSubmit();
          }}
          sx={{ mt: 2 }}
        >
          {formData.currentTab === 0 && (
            <UserInfoTab
              formData={formData}
              handleInputChange={handleInputChange}
              selectedUser={selectedUser}
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              teams={teams}
              memberTeamDropdownOpen={memberTeamDropdownOpen}
              setMemberTeamDropdownOpen={setMemberTeamDropdownOpen}
              ledTeamsDropdownOpen={ledTeamsDropdownOpen}
              setLedTeamsDropdownOpen={setLedTeamsDropdownOpen}
              handleCloseDropdown={handleCloseDropdown}
            />
          )}

          {selectedUser && formData.currentTab === 1 && formData.role !== 'admin' && formData.role !== 'accountant' && (
            <UserPTOTab
              formData={formData}
              handleInputChange={handleInputChange}
            />
          )}
          
          {selectedUser && 
            ((formData.role === 'admin' || formData.role === 'accountant') && formData.currentTab === 1 || 
             (formData.role !== 'admin' && formData.role !== 'accountant') && formData.currentTab === 2) && (
            <UserSecurityTab
              formData={formData}
              systemTwoFactorEnabled={systemTwoFactorEnabled}
              twoFactorUpdating={twoFactorUpdating}
              passwordChangeUpdating={passwordChangeUpdating}
              selectedUser={selectedUser}
              handleTwoFactorToggle={handleTwoFactorToggle}
              handleForcePasswordChangeToggle={handleForcePasswordChangeToggle}
              error={error}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'flex-end' }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          onClick={() => handleSubmit()} 
          variant="contained" 
          color="primary"
        >
          {selectedUser ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDialog;
